// extracted by mini-css-extract-plugin
export default {"loader":"MyProfile_loader__ffYqa"};